// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2276":"86ebf55ff0205c41","3764":"4362e4103e4432d2"}[chunkId] + ".js";
};